import "./about.scss"
import {FiGithub} from "react-icons/fi"
import {FaLinkedinIn} from "react-icons/fa"
import {MdEmail} from "react-icons/md"
import {BsChevronCompactDown} from "react-icons/bs"

export default function about() {
    return (
        <div className="about" id="about">
            <div className="container">
                <div className="aboutContainer">
                    <div className="left">
                        <img src="https://cdn.iconscout.com/icon/free/png-256/avatar-373-456325.png"/>
                        <button onClick={() => window.open('https://drive.google.com/file/d/19-fv4hwfPDoBTw026FDzINlqWObf-24p/view?usp=sharing')}>Download Resume</button>
                        <div className="buttonicons">
                            <button onClick={() => window.open('https://github.com/AdheenaBabu')}><FiGithub fontSize="23px"/></button>
                            <button onClick={() => window.open('https://www.linkedin.com/in/adheena-babu-92a80a1bb/')}><FaLinkedinIn fontSize="23px"/></button>
                            <button onClick={() => window.location.href = 'mailto:babu.adheena.2001@gmail.com'}><MdEmail fontSize="23px"/></button>
                        </div>
                    </div>
                    <div className="right">
                        <div className="rightContainer">
                            <h2>About Me</h2>
                            <p>
                                Hello World! This is Adheena.&#128075; I am a Computer Science undergrad from Amrita University, Coimbatore.
                                I got introduced to the world of possibilities that 1's and 0's can create only a few years back. But ever since, I 
                                have fallen in awe&#128558; and admiration&#128525; with this world of possibilities. 
                                My development journey started with front-end webpage development using HTML, CSS and a bit of JavaScript. 
                                And the journey now has covered Android application development using Java and Flutter app development using Dart and now stands at React js.
                                I look forward to learn Full Stack development&#129310; in the near future. If you would 
                                like to get in touch with me, feel free to drop an e-mail.
                            </p>
                        </div>
                    </div>
                </div>
                <a href="#works"><BsChevronCompactDown color="white" fontSize="3em"/></a>
            </div>
        </div>
    )
}
